import React, { ReactNode, ReactElement, useRef, useEffect } from 'react';
import { Container, makeStyles, Box, RootRef } from '@material-ui/core';
import { CreateCSSProperties } from '@material-ui/core/styles/withStyles';
import { useLocation } from 'react-router-dom';

import { colors } from '@novozymes/components';
import MarketSelector from 'components/dialogs/MarketSelector';
import { ScenarioParamsFetcher } from 'scenario/ScenarioGetter';
import { BETA_BANNER_HEIGHT, FOOTER_HEIGHT, HEADER_HEIGHT, PROCESS_HEADER_HEIGHT } from 'components/Constants';
import Header from './Header';
import ProcessHeader from './ProcessHeader';
import BottomNav from './BottomNav';
import FeedbackBanner from './FeedbackBanner';
import ErrorBanner from './ErrorBanner';

interface PageProps {
  children: NonNullable<ReactNode>;
  hideProcessHeader?: boolean;
  hideFooter?: boolean;
  isHomePage?: boolean;
  useMarketSelector?: boolean;
}

const useStyles = makeStyles(() => ({
  root: ({ isHomePage }: PageProps): CreateCSSProperties => ({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: isHomePage ? colors.bg2 : colors.bg1,
  }),
  scrollContainer: ({ hideProcessHeader, hideFooter }: PageProps): CreateCSSProperties => ({
    height: `calc(100vh - ${hideFooter ? '0px' : FOOTER_HEIGHT} - ${HEADER_HEIGHT} - ${BETA_BANNER_HEIGHT} - ${
      hideProcessHeader ? '0px' : PROCESS_HEADER_HEIGHT
    }) `,
    overflowY: 'auto',
    overflowX: 'hidden',
  }),
}));
const Page = (props: PageProps): ReactElement => {
  const {
    children,
    hideProcessHeader = false,
    hideFooter = false,
    isHomePage = false,
    useMarketSelector = false,
  } = props;
  const classes = useStyles(props);
  const location = useLocation();

  const scrollContainerRef = useRef<any>();

  useEffect(() => {
    if (scrollContainerRef?.current) {
      scrollContainerRef.current.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return (
    <ScenarioParamsFetcher>
      <Box className={classes.root}>
        <ErrorBanner />
        <FeedbackBanner />
        <Header isHomePage={isHomePage} />
        {!hideProcessHeader && <ProcessHeader />}
        {useMarketSelector && <MarketSelector />}
        <RootRef rootRef={scrollContainerRef}>
          <Box className={classes.scrollContainer}>
            <Container>{children}</Container>
          </Box>
        </RootRef>
        {!hideFooter && <BottomNav />}
      </Box>
    </ScenarioParamsFetcher>
  );
};

export default Page;
